import { crudFor } from "./dataClient";
import { seedUnits, seedUnitPosts } from "@/data/seed/units";

export const unitsCrud = crudFor("units", seedUnits);
export const unitPostsCrud = crudFor("unit_posts", seedUnitPosts);

export const unitsService = {
  async listUnits() {
    const rows = await unitsCrud.list((q) => q.eq("is_published", true).order("sort_order"));
    return rows
      .filter((u) => u.is_published !== false)
      .sort((a, b) => (a.sort_order || 0) - (b.sort_order || 0));
  },

  async searchUnits(query, deanery) {
    const all = await this.listUnits();
    const q = (query || "").toLowerCase();
    return all.filter((u) => {
      const matchQ =
        !q ||
        u.name?.toLowerCase().includes(q) ||
        u.parish_name?.toLowerCase().includes(q) ||
        u.area?.toLowerCase().includes(q) ||
        u.deanery?.toLowerCase().includes(q);
      const matchD = !deanery || deanery === "All" || u.deanery === deanery;
      return matchQ && matchD;
    });
  },

  async listDeaneries() {
    const all = await this.listUnits();
    return ["All", ...Array.from(new Set(all.map((u) => u.deanery).filter(Boolean)))];
  },

  getUnit(slug) {
    return unitsCrud.getBy("slug", slug);
  },

  async listFeatured(limit = 4) {
    const all = await this.listUnits();
    const featured = all.filter((u) => u.is_featured);
    return (featured.length ? featured : all).slice(0, limit);
  },

  async listUnitPosts(unitSlug) {
    const rows = await unitPostsCrud.list((q) =>
      q.eq("unit_slug", unitSlug).eq("is_published", true).order("created_at", { ascending: false })
    );
    return rows.filter((p) => p.unit_slug === unitSlug && p.is_published !== false);
  },

  /** Sum of `member_count` across all published units — site-wide membership total. */
  async getTotalMemberCount() {
    const units = await this.listUnits();
    return units.reduce((sum, unit) => sum + (Number(unit.member_count) || 0), 0);
  },

  /** Count of published units — site-wide unit total. */
  async getPublishedUnitCount() {
    const units = await this.listUnits();
    return units.length;
  },
};
